import PosthogService from '~/services/posthog/PosthogService';

export interface IConfirmCandidateProfileClickedPayload {
  shiftId: string;
}

/**
 * Fires when an office clicks the profile button for a professional on the Confirm Candidate page
 * Event: dental_portal:confirm_candidate:profile_clicked
 */
export function fireConfirmCandidateProfileClicked(
  payload: IConfirmCandidateProfileClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:confirm_candidate:profile_clicked', {
    shift_id: payload.shiftId,
  });
}
